import { LocalStyles } from "@paperbits/common/styles";

export class ReportsModel {
    /**
     * Widget local styles.
     */
    public styles: LocalStyles = {};
}
